import Masonry from 'masonry-layout';

export class ImageList {
    private readonly imageList: HTMLElement | null;

    constructor(imageList: HTMLElement) {
        this.imageList = imageList;
        this.addEventListeners();
        this.updateMasonry();
    }

    updateMasonry(): void {
        if (!this.imageList) {
            return;
        }

        requestAnimationFrame(() => {
            const msnry = (Masonry as any).data(this.imageList);

            if (msnry) {
                msnry.layout();
            }
        });
    }

    addEventListeners() {
        window.addEventListener('mediaListLayoutChanged', this.updateMasonry.bind(this));
    }

    removeEventListeners() {
        window.removeEventListener('mediaListLayoutChanged', this.updateMasonry.bind(this));
    }

    destroy() {
        this.removeEventListeners();
    }
}
